import React from "react";
import NebulaBackground from "./NebulaBackground";
import { motion } from "framer-motion";

const SplashScreen = () => {
  return (
    <div className="relative h-screen flex flex-col justify-center items-center overflow-hidden">
      <NebulaBackground />
      <motion.h1
        className="text-5xl md:text-6xl font-bold text-center text-white z-10"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Hi, I'm <span className="text-indigo-400">Daniel</span>
      </motion.h1>
      <motion.h2
        className="text-lg md:text-2xl text-gray-300 mt-2 z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 1 }}
      >
        A Software Engineer
      </motion.h2>
    </div>
  );
};

export default SplashScreen;
